export default __webpack_public_path__ + "static/media/Airbnb_Logo.6397b178.png";